

import barba from '@barba/core'
import barbaPrefetch from '@barba/prefetch';
import Prevent from "./Prevent"
import PageTransition from "./PageTransition"
const pageTransition = new PageTransition

export default class{
	
	constructor(){
        let display_loading = true;
        if(process.env.MIX_DISP_LOADING == "false" && process.env.NODE_ENV == "development"){
            display_loading = false;
        }

        // window.addEventListener("popstate", (e) => {
        //     display_loading = false
        // })
        barba.use(barbaPrefetch);
        barba.init({
            preventRunning: true,
            prevent: Prevent,
            timeout: 10000,
            cacheIgnore: ['/contact/','/entry/'],
            views: [
                {
                    namespace: 'not-loading',
                    beforeEnter(data) {
                        if(pageTransition.mask){
                            pageTransition.mask.style.visibility = 'hidden' 
                        }
                        display_loading = false;
                    },
                    beforeLeave(data) {
                        if(pageTransition.mask){
                            pageTransition.mask.style.visibility = 'visible'
                        }
                        display_loading = true;
                    },
                },
                {
                    namespace: 'information',
                    beforeEnter(data) {
                        // console.log(data)
                        if(data.current.namespace == 'information' && data.next.namespace == 'information'){
                            if(pageTransition.mask){
                                pageTransition.mask.style.visibility = 'hidden' 
                            }
                            display_loading = false;
                            
                        }
                    },
                    beforeLeave(data) {
                        if( data.next.namespace !== 'information'){
                            if(pageTransition.mask){
                                pageTransition.mask.style.visibility = 'visible'
                            }
                            display_loading = true;
                        }
                    },
                },
            ],
            requestError: (trigger, action, url, response) => {
                // go to a custom 404 page if the user click on a link that return a 404 response status
                if (trigger === 'back') {
                    if(pageTransition.mask){
                        pageTransition.mask.style.visibility = 'visible'
                    }
                    display_loading = true;
                }
                if (trigger === 'forward') {
                    if(pageTransition.mask){
                        pageTransition.mask.style.visibility = 'visible'
                    }
                    display_loading = true;
                }
            
                // prevent Barba from redirecting the user to the requested URL
                // this is equivalent to e.preventDefault() in this context
                // return false;
            },
            transitions: [{

                // apply only when leaving `[data-barba-namespace="home"]`
                // from: 'home',

                // apply only when transitioning to `[data-barba-namespace="products | contact"]`
                // to: {
                //     namespace: [
                //         'products',
                //         'contact'
                //     ]
                // },
            
                // apply only if clicked link contains `.cta`
                // custom: ({ current, next, trigger })
                // => trigger.classList && trigger.classList.contains('cta'),

                // do leave and enter concurrently
                sync: true,
                
                async beforeOnce(data) {
                    if(display_loading){
                        await pageTransition.beforeOnce(data)       
                    }
                },
                async once(data) {
                    if(display_loading){
                        await pageTransition.once(data)
                    }
                },
                async afterOnce(data) {
                    if(display_loading){
                        await pageTransition.afterOnce(data)
                    }
                },
                async beforeLeave(data) {
                    
                    if(data.trigger==='back' || data.trigger==='forward'){
                        display_loading = false
                    }else{
                        display_loading = true
                    }
                    if(display_loading){
                        
                        await pageTransition.beforeLeave(data)
                    }
                },
                async leave(data) {
                    
                    if(display_loading){
                        await pageTransition.leave(data)
                    }
                },
                async afterLeave(data) {
                    if(display_loading){
                        await pageTransition.afterLeave(data)
                    }
                },
                async beforeEnter(data) {
                    if(display_loading){
                        await pageTransition.beforeEnter(data)
                    }
                },
                async enter(data) {
                    if(display_loading){
                        await pageTransition.enter(data)
                    }
                },
                async afterEnter(data) {
                    if(display_loading){
                        await pageTransition.afterEnter(data)
                    }
                },
                async after(data) {
                    if(display_loading){
                        await pageTransition.after(data)
                    }
                }
            }]
        }); 
	}
    initialScroll (){
        const ua = window.navigator.userAgent.toLowerCase();
        const wrapper = document.querySelector('#wrapper')
        
        if( location.hash == "" ){
            // if(ua.indexOf("windows nt") !== -1) { 
            //     if(wrapper){
                    wrapper.scrollTop = 0
            //     }
            // }else{
                window.scrollTo(0,0);
            // }
        }else{
            let digit = location.hash.replace(/^#/,"");
            let anchor = document.getElementById( digit );
            if ( !anchor ) return;
            
            if(anchor){
                const rect = anchor.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                let top = rect.top + scrollTop;
                const header = document.querySelector('[data-header]');
                if(header){
                    top = top - header.clientHeight;
                    
                }
                // if(ua.indexOf("windows nt") !== -1) { 
                //     if(wrapper){
                        // wrapper.scrollTop = top
                //     }
                // }else{
                    window.scrollTo(0,top);
                // }
            }
            
        }
    }
}